__turbopack_context__.v({
  "className": "SHzbTG_className",
  "variable": "SHzbTG_variable",
});
